import { useEffect } from 'react'
import { PageSizeEnum } from '@/constants/page-size.enum'
import useIntersectionObserver from '@/containers/hooks/useIntersectionObserver'
import usePageInfo from '@/containers/hooks/usePageInfo'
import { ModelProduct } from '@/containers/models'
import { useRecommendedSimilarProductsQuery } from '@/graphql/generated/hooks'

const defaultPageSize = PageSizeEnum.PageSize20

const useSimilarProductContainerHook = (productId?: string, pageSize: number = defaultPageSize) => {
  const { pageNumber, setPageNumber, getTablePageInfoVariables } = usePageInfo(defaultPageSize)

  const {
    data,
    loading,
    refetch,
    fetchMore: fetchMoreRecommendedProducts,
  } = useRecommendedSimilarProductsQuery({
    variables: {
      id: productId ?? '',
      pageInfo: {
        first: pageSize,
      },
    },
    skip: !productId,
  })

  const { elementRef } = useIntersectionObserver(() => {
    setPageNumber((prev) => prev + 1)
  })

  const recommendedSimilarProducts = data?.recommendedSimilarProducts?.edges.map((e: any) => e?.node) || []

  useEffect(() => {
    if (pageNumber === 1) {
      return
    }
    fetchMoreRecommendedProducts({
      variables: {
        pageInfo: {
          first: defaultPageSize,
          after: getTablePageInfoVariables(pageNumber + 1, defaultPageSize).pageInfo.after,
        },
      },
      // updateQuery 가 호출이 안되었다고 lint-error 가 발생하여 @ts-ignore 처리
      // @ts-ignore
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult
        }
        return {
          ...fetchMoreResult,
          recommendedSimilarProducts: {
            ...fetchMoreResult.recommendedSimilarProducts,
            edges: [
              ...(previousResult.recommendedSimilarProducts?.edges ?? []),
              ...(fetchMoreResult.recommendedSimilarProducts?.edges ?? []),
            ],
          },
        }
      },
    })
  }, [pageNumber])

  useEffect(() => {
    if (productId) {
      refetch()
    }
  }, [productId])

  return {
    recommendedSimilarProducts,
    loading,
    totalCount: data?.recommendedSimilarProducts?.totalCount || 0,
    hasNextPage: data?.recommendedSimilarProducts?.pageInfo.hasNextPage || false,
    elementRef,
  }
}

export default useSimilarProductContainerHook
